import { t } from "@lingui/macro";
import { Box, TextField } from "@mui/material";
import { BoltDisplayCategory } from "@WahooFitness/crux-js-display-cfg";
import { MenuList, MenuListItemType, SlidingDrawer, WfButton } from "@WahooFitness/redesignr";
import { useConfigContext } from "@WahooFitness/wahoo-offline-mfe";
import { ChangeEventHandler, useEffect, useRef } from "react";

interface AddDataFieldDrawerProps {
  open: boolean;
  handleClose: () => void;
  lastSelectedCategory: BoltDisplayCategory | undefined;
  changingPedalMonitorGraphType: boolean;
  searchTerm: string;
  handleChangeSearchTerm: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  menuItems: MenuListItemType[];
  headerProps: {
    title: string;
    primaryLeftActionItem: {
      icon: JSX.Element;
      action: () => void;
    };
  };
}

const AddDataFieldDrawer: React.FC<AddDataFieldDrawerProps> = ({
  handleClose,
  open,
  lastSelectedCategory,
  changingPedalMonitorGraphType,
  searchTerm,
  handleChangeSearchTerm,
  menuItems,
  headerProps,
}: AddDataFieldDrawerProps) => {
  const { globalBottomPadding, platform } = useConfigContext();

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open && inputRef.current) {
      inputRef.current.focus();
    }
  }, [open]);

  return (
    <SlidingDrawer
      platform={platform}
      globalBottomPadding={globalBottomPadding}
      open={open}
      title={headerProps.title}
      hidePuller
      hideDivider
      elevation={4}
      handleOpen={() => {}}
      handleClose={handleClose}
      drawerHeight="95vh"
      leftAction={
        <WfButton
          hierarchy="text"
          onClick={headerProps.primaryLeftActionItem.action}
          iconOnly
          aria-label="go back"
        >
          {headerProps.primaryLeftActionItem.icon}
        </WfButton>
      }
    >
      <Box display="flex" flexDirection="column" gap={2}>
        {!lastSelectedCategory && !changingPedalMonitorGraphType && (
          <Box width="100%" px={2} mt={1}>
            <TextField
              aria-label="search data fields"
              fullWidth
              label={t`Search`}
              size="medium"
              variant="outlined"
              value={searchTerm}
              onChange={handleChangeSearchTerm}
            />
          </Box>
        )}
        <MenuList listItems={menuItems} variant="outlined" />
      </Box>
    </SlidingDrawer>
  );
};

export default AddDataFieldDrawer;
